import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import { SvgUri } from 'react-native-svg';
import { UIConfig } from '../types/ui-config/index';
import { DyteI18n, useLanguage } from '../lib/lang';
import { StyleProps } from '../types/ui-config/root';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  meeting,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  config,
  logoUrl,
  style,
  t,
}: {
  meeting?: any;
  config?: UIConfig;
  logoUrl?: string;
  style?: StyleProps;
  t?: DyteI18n;
}) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const defaultLang = useLanguage();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  t = t ?? defaultLang;
  const styles = StyleSheet.create({
    container: {
      alignItems: 'center',
      justifyContent: 'center',
    },
  });
  //console.log(config.designTokens.logo, logoUrl);
  return (
    <View style={styles.container}>
      {logoUrl && logoUrl.toString().trim().length > 0 && (
        <SvgUri
          uri={logoUrl}
          width={style ? style.width ?? 50 : 50}
          height={style ? style.height ?? 50 : 50}
          viewBox="0 0 90 40"
          fill={colors.text}
        />
      )}
    </View>
  );
}
